import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import Table, {
  TableBody, TableContainer, TableRow, SocialMediaValueCell,
  SocialMediaTableCells,
} from '@fuww/library/src/Table';
import IntelligencePageLayout from '@fuww/library/src/Layouts/IntelligencePage';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Hero from '../components/Hero';
import facebookPages from '../data/staticPages/i/facebook-fashion-index.json';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import FashionIndexTableHead from '../components/FashionIndex/TableHead';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/Sqq96nb2UKVidahodazuba2X7Q4cflaNgpEu93hajss/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/pFigsVGS3lfx4r0l5DeOLeVQ_MlgHoY2xaimDj7VyPs/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/9zZz2XF4d1joZNLtaD_BpFXIsrlXc09U7tGrOvCljAs/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfbW9iaWxlLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/ddxuVnU02VSqt79xV9Im1vHL9sIkVqmgDk9cOYylBr0/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/vhkM2hB302IEpcgXIVOQWXvyUxC4gyRw5xI1QxdSYEQ/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/5l0CxHRaxrMNroqUHQ_z4JQnQf-9LAQIy2gyR-wJzXo/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/jEulinQeNc0lsl6he2h4BgeXWsYg7Aawfn52dcPePEQ/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFjZWJvb2tfZmFzaGlvbl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
  ],
};

const FacebookFashionIndexPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'facebook-fashion-index',
    'facebookFashionIndex',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['facebookFashionIndex.title'])}
        description={intl.formatMessage(
          messages['facebookFashionIndex.description'],
        )}
      />
      <IntelligencePageLayout
        description={
          intl.formatMessage(messages['facebookFashionIndex.description'])
        }
        content={(
          <>
            <TableContainer>
              <Table
                aria-label={intl.formatMessage(
                  messages['facebookFashionIndex.table.ariaLabel'])}
              >
                <FashionIndexTableHead />
                <TableBody>
                  {facebookPages.map(({
                    brand,
                    likes,
                    link,
                  }, index) => (
                    <TableRow key={brand}>
                      <SocialMediaTableCells
                        index={index + 1}
                        link={link}
                        value={brand}
                      />
                      <SocialMediaValueCell value={likes} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'facebookFashionIndex.source'
              ]),
            }}
            />
          </>
        )}
        subTitle={intl.formatMessage(messages['facebookFashionIndex.subTitle'])}
        title={intl.formatMessage(messages['facebookFashionIndex.title'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

FacebookFashionIndexPage.getLayout = (page: ReactElement) => (
  <Layout header={(
    <Hero
      imageUrls={headerImageUrls}
      alt="Facebook Fashion Index"
    />
    )}
  >
    {page}
  </Layout>
);

FacebookFashionIndexPage.getInitialProps = redirectRouteToDomain(
  'facebook-fashion-index',
);

export default FacebookFashionIndexPage;
